import React from 'react';
import { render } from 'react-dom';
import App from 'app';
import './i18n';
import ReactGA from 'react-ga';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

Sentry.init({
  dsn: 'https://a0cff95421e04c6eb35d77b5a0baf588@o507202.ingest.sentry.io/6263880',
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

ReactGA.initialize(process.env.ANALYTICS_TRACKING_CODE || '');

const rootEl = document.querySelector('#app');

if (process.env.NODE_ENV === 'development') {
  const { AppContainer } = require('react-hot-loader');

  render(
    <AppContainer warnings={false}>
      <App />
    </AppContainer>,
    rootEl
  );

  if (module.hot) {
    module.hot.accept('./app', () => {
      requestAnimationFrame(() =>
        render(
          <AppContainer warnings={false}>
            <App key={Math.random()} />
          </AppContainer>,
          rootEl
        )
      );
    });
  }
} else {
  render(<App />, rootEl);
}
